(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = ['$scope', '$state', '$window', 'LandingPageService', 'ClearLocalStorageService', 'AgreementsWorkflowService', 'ipmConstants', 'SurveyResultService',
        'Principal', 'tmhDynamicLocale', '$rootScope', '$uibModal'];

    function LandingPageController($scope, $state, $window, LandingPageService, ClearLocalStorageService, AgreementsWorkflowService, constants, SurveyResultService,
        Principal, tmhDynamicLocale, $rootScope, $uibModal) {
        var vm = this;
        vm.landingpage = null;
        vm.haqBatteries = [];
        vm.slides = [];
        vm.myInterval = false;
        vm.noWrapSlides = false;
        vm.active = true;
        vm.percentCompleted = 100; // completed 100%
        vm.isProcessing = false;
        vm.step1 = 1;
        vm.step2 = 2;
        vm.step3 = 3;
        vm.step4 = 4;
        vm.stepPsychIntake = 'Psych Intake';
        vm.openCountDialog = false;
        vm.currentStep = null;
        vm.isHideHAQStep = false;
        vm.isHideHAQStepBackground = false;
        vm.isCompletedAllStep = false;
        vm.langdingPageSteps = [];
        vm.isPatientNoNPQ = false;
        vm.isLaunchAction = false;
        vm.isCompleteHAQ = false;
        vm.hasHaqAdhocTesting = false;
        vm.haqAdhocId = null;
        vm.batteryTestAdhocId = null;
        vm.adhocTestName = '';
        vm.percentProgressOfHAQAdhoc = 0;
        vm.percentProgressOfPsychIntake = 0;
        vm.isLaunchFromHaqAdhoc = false;
        vm.currentSurveyResultId = null;
        vm.disableAutoHaqNewStep = true; // Disable Launch HAQ
        vm.isLaunching = getLaunchFrom() != null;
        vm.clickAction = clickAction;
        vm.isShowStep = isShowStep;
        vm.getNumberOfNpqNotYetComplete = getNumberOfNpqNotYetComplete;
        vm.getNumberOfPsychIntakeFormNotYetComplete = getNumberOfPsychIntakeFormNotYetComplete;
        vm.isCompletedAgreementStep = isCompletedAgreementStep;
        vm.isCompletedNPQStep = isCompletedNPQStep;
        vm.isCompletedPsychStep = isCompletedPsychStep;
        vm.isCompletedHAQStep = isCompletedHAQStep;
        vm.isCompletedHAQBatteryStep = isCompletedHAQBatteryStep;
        vm.isResumeStep = isResumeStep;
        vm.isStartStep = isStartStep;
        vm.percentTextClass = percentTextClass;
        vm.timeRemainingTextClass = timeRemainingTextClass;
        vm.isShowTextStep = isShowTextStep;
        vm.isShowRemainingText = isShowRemainingText;
        vm.isShowCompletedText = isShowCompletedText;
        vm.isShowApproxText = isShowApproxText;
        vm.itemLandingPageClick = itemLandingPageClick;
        vm.itemLandingPageClickDownload = itemLandingPageClickDownload;
        vm.handleHAQBodyPartSubmitSuccess = handleHAQBodyPartSubmitSuccess;
        vm.isDisplayItemLandingPageForPatientNoNPQ = isDisplayItemLandingPageForPatientNoNPQ;
        vm.isDisplayItemLandingPageForAdhocTesting = isDisplayItemLandingPageForAdhocTesting;
        vm.isAgreementSignedAllByAPI = isAgreementSignedAllByAPI;
        vm.navigateAdhocTesting = navigateAdhocTesting;
        vm.navigateHaqBatteryTesting = navigateHaqBatteryTesting;
        vm.isShowAdhocTesting = isShowAdhocTesting;
        vm.checkShowActionStart = checkShowActionStart;
        vm.isShowHaqBatteries = isShowHaqBatteries;
        vm.isHaqBatteryCompleted = isHaqBatteryCompleted;
        vm.startPsychIntakeForm = startPsychIntakeForm;

        init();

        function init() {
            initLandingPage();
        }

        function initLandingPage() {
            initLandingPageBackground();

            vm.isLaunchAction = getHAQDirectLink();
            vm.noWait = $window.localStorage.getItem(constants.NOWAIT);
            var haqId = $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
            var _passRestriction = $window.localStorage.getItem(constants.PASS_RESTRICTION);
            if (_passRestriction && true == Boolean(_passRestriction)) {
                vm.byPassRestriction = true;
            }

            LandingPageService.getLandingPage(vm.isLaunchAction, vm.noWait, haqId).then(function (response) {
                vm.landingpage = response ? response.data : null;
                // IPMproject-B1357 Landing page: The language is EN while the language of patient is SP
                var langKeyPatient = vm.landingpage.langKey;
                if (langKeyPatient) {
                    $rootScope.$emit("changeLanguage", { langKey: langKeyPatient });
                }

                if (vm.landingpage) {
                    vm.hasHaqAdhocTesting = vm.landingpage.hasHaqAdhocTesting;
                    if (!vm.hasHaqAdhocTesting && isLaunchFromHaqAdhoc()) {
                        ClearLocalStorageService.clearLaunchFrom();
                    }
                    vm.haqAdhocId = vm.landingpage.latestSurveyResultAdhocId;
                    vm.batteryTestAdhocId = vm.landingpage.latestBatteryTestAdhocId;
                    vm.adhocTestName = vm.landingpage.latestAdhocTestName;
                    vm.percentProgressOfHAQAdhoc = vm.landingpage.percentProgressOfHAQAdhoc;
                    vm.isLaunchFromHaqAdhoc = vm.landingpage.isLaunchFromHaqAdhoc;
                    vm.currentSurveyResultId = vm.landingpage.currentSurveyResultId;
                    vm.haqBatteries = vm.landingpage.haqBatteries;
                    vm.percentProgressOfPsychIntake = vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake;
                }

                setCurrentStep();
                // set isHideHAQStep
                setIsHideHAQStep();

                if (vm.landingpage.patientType === 'NEW_PATIENT_NO_NPQ') {
                    vm.batteryTestId = vm.landingpage && vm.landingpage.haqResponseInfo ? vm.landingpage.haqResponseInfo.batteryTestId : null;
                    vm.isPatientNoNPQ = true;
                    // define common variable
                    var completedTextTranslate = 'ipmApp.landingPage.details.completed';
                    var terminadoTextTranslate = 'ipmApp.landingPage.details.terminado';
                    var approxTextTranslate = 'ipmApp.landingPage.details.approx';
                    var minTextTranslate = 'ipmApp.landingPage.details.min';
                    var remainingTextTranslate = 'ipmApp.landingPage.details.remaining';
                    var clickToStartTextTranslate = 'ipmApp.landingPage.action.clickToStart';
                    var clickToResumeTextTranslate = 'ipmApp.landingPage.action.clickToResume';
                    var clickToDownloadTextTranslate = 'ipmApp.landingPage.action.clickToDownload';

                    var agreementItem = {
                        isAgreement: true,
                        image: './content/images/assets_agreement.png',
                        titleTextTranslate: 'ipmApp.landingPage.details.newPatientAgreements',
                        stepNumber: 1,
                        isCurrentStep: vm.landingpage.agreement.percentProgressOfAgreement !== vm.percentCompleted,
                        percentProgress: vm.landingpage.agreement.percentProgressOfAgreement,
                        numberTimeRemaining: vm.landingpage.agreement.numberTimeRemainingOfAgreement,
                        canDownload: true,
                        completedTextTranslate: completedTextTranslate,
                        terminadoTextTranslate: terminadoTextTranslate,
                        approxTextTranslate: approxTextTranslate,
                        minTextTranslate: minTextTranslate,
                        remainingTextTranslate: remainingTextTranslate,
                        clickToStartTextTranslate: clickToStartTextTranslate,
                        clickToResumeTextTranslate: clickToResumeTextTranslate,
                        clickToDownloadTextTranslate: clickToDownloadTextTranslate
                    }

                    var haqItem = {
                        isHAQ: true,
                        image: './content/images/assets_haq.png',
                        titleTextTranslate: 'ipmApp.landingPage.details.healthAssessmentQuestionnaire',
                        stepNumber: 2,
                        isCurrentStep: vm.landingpage.agreement.percentProgressOfAgreement === vm.percentCompleted && vm.landingpage.percentProgressOfHAQ !== vm.percentCompleted,
                        percentProgress: vm.landingpage.percentProgressOfHAQ,
                        numberTimeRemaining: vm.landingpage.numberTimeRemainingOfHAQ,
                        completedTextTranslate: completedTextTranslate,
                        terminadoTextTranslate: terminadoTextTranslate,
                        approxTextTranslate: approxTextTranslate,
                        minTextTranslate: minTextTranslate,
                        remainingTextTranslate: remainingTextTranslate,
                        clickToStartTextTranslate: clickToStartTextTranslate,
                        clickToResumeTextTranslate: clickToResumeTextTranslate,
                        clickToDownloadTextTranslate: clickToDownloadTextTranslate
                    }

                    vm.langdingPageSteps = [agreementItem, haqItem];
                }

                vm.isCompletedAllStep = isCompletedAllStep();

            });
        }

        function setIsHideHAQStep() {
            //vm.isHideHAQStep = (vm.landingpage ? vm.landingpage.haqTestServiceExclusion : false) || isLaunchFromHaqAdhoc() || checkDisableAutoHaqNewStep();
            vm.isHideHAQStep = true; // IPMproject-891 - Admin/Staff Portal - Patient Details Page – New Batteries Table: default hide HAQ
            vm.isHideHAQStepBackground = vm.landingpage ? vm.landingpage.haqTestServiceExclusion && vm.currentStep === vm.step3 && !isCompletedHAQStep() : false;
        }

        function initLandingPageBackground() {
            var currIndex = 0;
            vm.slides.push({
                image: 'content/images/assets_bg.jpg',
                id: currIndex++
            });
        }

        function clickAction(step, $event) {
            if (vm.isPatientNoNPQ) {
                angular.forEach(vm.langdingPageSteps, function (step) {
                    if (step && step.isCurrentStep) {
                        itemLandingPageClick(step);
                        return;
                    }
                });
                return;
            }

            if (step && step == vm.step1 && isCompletedAgreementStep() && !vm.isProcessing) {
                if (!vm.isAgreementSignedAllByAPI()) {
                    clickToDownload();
                }
                return;
            }

            if ((vm.currentStep && vm.currentStep === vm.stepPsychIntake) || (step && step == vm.stepPsychIntake)) {
                startPsychIntakeForm();
                return;
            } else {
                $window.localStorage.removeItem(constants.PSYCH_INTAKE_FORM_ID);
            }

            if (step && step != vm.currentStep) {
                return;
            }

            if ((!vm.currentStep || vm.currentStep && vm.currentStep === 4) &&
                !isCompletedAllHAQBatteryStep()) {
                navigateHaqBatteryTestingFistNotCompleted();
                return;
            }

            if ((!vm.currentStep || vm.currentStep && vm.currentStep === 4) && isCompletedAllHAQBatteryStep() && isCompletedHAQStep() && !isLaunchFromHaq() && !isCompletedHAQAdhocStep()) {
                navigateAdhocTesting();
                return;
            }
            goToHome();
        }

        function startPsychIntakeForm() {
            var psychIntakeFormId = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID);
            if (!psychIntakeFormId && vm.landingpage.psychIntakeForm.psychIntakeFormId) {
                psychIntakeFormId = vm.landingpage.psychIntakeForm.psychIntakeFormId;
                $window.localStorage.setItem(constants.PSYCH_INTAKE_FORM_ID, psychIntakeFormId);
            }
            if (psychIntakeFormId) {
                $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
                if (vm.landingpage && vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete > 1) {
                    openPsychCountDialog(vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete);
                } else {
                    goToHome();
                }
            }
        }

        function openPsychCountDialog(countPsych) {
            vm.openCountDialog = true;
            $uibModal.open({
                templateUrl: 'app/landing-page/psych-count-dialog.html',
                controller: 'PsychCountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    count: function () {
                        return countPsych;
                    }
                }
            }).result.then(function (result) {
                vm.openCountDialog = false;
                if (result && result === true) {
                    goToHome();
                }
            }, function () {
                vm.openCountDialog = false;
            });
        }

        function navigateHaqBatteryTestingFistNotCompleted() {
            if (vm.landingpage && vm.haqBatteries && vm.haqBatteries.length > 0) {
                const haqBatteryItemNotCompleted = vm.haqBatteries.find(function (item) {
                    return item && item.percentProgress < vm.percentCompleted;
                });
                if (haqBatteryItemNotCompleted) {
                    navigateHaqBatteryTesting(haqBatteryItemNotCompleted);
                }
            }
        }

        function goToHome() {
            ClearLocalStorageService.setLandingPage(true); // landing page is null or false will open landing page
            $state.go('home');
        }

        function navigateAdhocTesting() {
            ClearLocalStorageService.setSurveyResultId(vm.haqAdhocId);
            $state.go('survey-workflow', { id: vm.batteryTestAdhocId });
        }

        function navigateHaqBatteryTesting(haqBattery) {
            if (!haqBattery.batteryTestId || !haqBattery.surveyResultId || isHaqBatteryCompleted(haqBattery)) {
                return;
            }
            ClearLocalStorageService.setSurveyResultId(haqBattery.surveyResultId);
            $state.go('survey-workflow', { id: haqBattery.batteryTestId });
        }

        function clickToDownload() {
            vm.isProcessing = true;
            if (isCompletedAgreementStep()) {
                AgreementsWorkflowService.downloadAgreements().then(function (response) {
                    vm.isProcessing = false;
                });
            }
        }

        function isCompletedAgreementStep() {
            if (vm.isAgreementSignedAllByAPI() || !vm.isShowStep(vm.step1)) {
                return true;
            }
            return vm.landingpage && vm.landingpage.agreement.percentProgressOfAgreement && vm.landingpage.agreement.percentProgressOfAgreement === vm.percentCompleted ? true : false;
        }

        function isCompletedNPQStep() {
            return vm.landingpage && vm.landingpage.npq.percentProgressOfNPQ && vm.landingpage.npq.percentProgressOfNPQ == vm.percentCompleted ? true : false;
        }

        function isCompletedPsychStep() {
            return vm.landingpage && vm.landingpage.psychIntakeForm &&
                vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake &&
                vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake == vm.percentCompleted ? true : false;
        }

        function isCompletedHAQStep() {
            if (checkDisableAutoHaqNewStep()) {
                return true;
            }
            return vm.landingpage && vm.landingpage.percentProgressOfHAQ && vm.landingpage.percentProgressOfHAQ == vm.percentCompleted ? true : false;
        }

        function isCompletedHAQBatteryStep(haqBattery) {
            return vm.landingpage && haqBattery && haqBattery.percentProgress == vm.percentCompleted ? true : false;
        }

        function isCompletedAllHAQBatteryStep() {
            if (vm.landingpage && vm.haqBatteries && vm.haqBatteries.length > 0) {
                return vm.haqBatteries.every(function (item) {
                    return item && item.percentProgress === vm.percentCompleted;
                });
            }
            return true;
        }

        function isCompletedHAQAdhocStep() {
            return vm.landingpage && ((vm.landingpage.percentProgressOfHAQAdhoc && vm.landingpage.percentProgressOfHAQAdhoc === vm.percentCompleted) || !vm.hasHaqAdhocTesting);
        }

        function isStartStep(step) {
            if (step && step == vm.step1) {
                return !isCompletedAgreementStep() && !isResumeStep(step);
            } else if (step && step == vm.step2) {
                return !isCompletedNPQStep() && !isResumeStep(step);
            } else if (step && step == vm.step3) {
                return !isCompletedHAQStep() && !isResumeStep(step);
            } else if (step && step == vm.step4) {
                return !isCompletedHAQAdhocStep() && !isResumeStep(step);
            } else if (step && step == vm.stepPsychIntake) {
                return !isCompletedPsychStep() && !isResumeStep(step);
            }
        }

        function isResumeStep(step) {
            if (step && step == vm.step1) {
                return vm.landingpage && vm.landingpage.agreement.percentProgressOfAgreement && vm.landingpage.agreement.percentProgressOfAgreement > 0 && vm.landingpage.agreement.percentProgressOfAgreement < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step2) {
                return vm.landingpage && vm.landingpage.npq.percentProgressOfNPQ && vm.landingpage.npq.percentProgressOfNPQ > 0 && vm.landingpage.npq.percentProgressOfNPQ < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step3) {
                return vm.landingpage && vm.landingpage.percentProgressOfHAQ && vm.landingpage.percentProgressOfHAQ > 0 && vm.landingpage.percentProgressOfHAQ < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step4) {
                return vm.landingpage && vm.landingpage.percentProgressOfHAQAdhoc && vm.landingpage.percentProgressOfHAQAdhoc > 0 && vm.landingpage.percentProgressOfHAQAdhoc < vm.percentCompleted ? true : false;
            } else if (step && step == vm.stepPsychIntake) {
                return vm.landingpage && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake > 0 && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake < vm.percentCompleted ? true : false;
            }
        }

        function isShowStep(step) {
            if (step === vm.step1) {
                if (getKeepLandingPage()) {
                    return false;
                }
                if (vm.isLaunching) {
                    return getLaunchFrom() === constants.PATIENT_AGREEMENT;
                }
                return vm.landingpage && vm.landingpage.agreement.showCard == true ? true : false
            }
            if (step === vm.step2) {
                if (getKeepLandingPage() || vm.isLaunching) {
                    return false;
                }
                return vm.landingpage && vm.landingpage.npq.showCard == true ? true : false;
            }
            if (step === vm.step3) {
                return !vm.isHideHAQStep;
            }
            if (step === vm.stepPsychIntake) {
                if (vm.isLaunching) {
                    return false;
                }
                return vm.landingpage && vm.landingpage.psychIntakeForm.showCard;
            }
            return true;
        }

        function isShowAdhocTesting() {
            return vm.hasHaqAdhocTesting && (!vm.isLaunching || (vm.isLaunching && isLaunchFromHaqAdhoc()));
        }

        function isShowHaqBatteries() {
            return vm.haqBatteries && vm.haqBatteries.length > 0 && (!vm.isLaunching || (vm.isLaunching && getLaunchFrom() === constants.HAQ_BATTERY));
        }

        function isHaqBatteryCompleted(haqBattery) {
            return vm.haqBatteries && haqBattery && (haqBattery.surveyResultStatus === 'COMPLETE' || haqBattery.surveyResultStatus === 'DOWNLOADED');
        }

        function isLaunchFromHaqAdhoc() {
            return getLaunchFrom() === constants.HAQ_ADHOC;
        }

        function checkDisableAutoHaqNewStep() {
            return vm.disableAutoHaqNewStep && vm.landingpage && !vm.landingpage.currentSurveyResultId;
        }

        function checkShowActionStart() {
            return !vm.isCompletedAllStep;
        }

        function isLaunchFromHaq() {
            return getLaunchFrom() === constants.HAQ;
        }
        function isShowTextStep(step) {
            if (step === vm.step3) {
                if (getHAQDirectLink() || (!isShowStep(vm.step1) && !isShowStep(vm.step2))) {
                    return false;
                }
            }
            return true;
        }

        function isShowRemainingText(percent) {
            if (percent && percent > 0 && percent < vm.percentCompleted) {
                return true;
            }
            return false;
        }

        function isShowCompletedText(percent) {
            if (percent && percent === vm.percentCompleted) {
                return true;
            }
            return false;
        }

        function isShowApproxText(percent) {
            if (percent && percent > 0) {
                return false;
            }
            return true;
        }

        function getHAQDirectLink() {
            var _surveyResultId = getSurveyResultId();
            return _surveyResultId && true === Boolean(_surveyResultId);
        }

        function getSurveyResultId() {
            return ClearLocalStorageService.getSurveyResultId();
        }

        function getLaunchFrom() {
            return ClearLocalStorageService.getLaunchFrom();
        }

        function getKeepLandingPage() {
            var _keepLandingPage = $window.localStorage.getItem(constants.KEEP_LANDING_PAGE);
            return _keepLandingPage && true === Boolean(_keepLandingPage);
        }

        function getNumberOfNpqNotYetComplete() {
            return vm.landingpage ? vm.landingpage.npq.numberOfNPQNotYetComplete : 0;
        }

        function getNumberOfPsychIntakeFormNotYetComplete() {
            return vm.landingpage ? vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete : 0;
        }

        function percentTextClass(percent) {
            if (percent && percent == vm.percentCompleted) {
                return 'text-success';
            } else if (percent && percent > 0 && percent < vm.percentCompleted) {
                return 'text-warning';
            }
            return '';
        }

        function timeRemainingTextClass(percent) {
            if (percent && percent == vm.percentCompleted) {
                return '';
            } else if (percent && percent > 0 && percent < vm.percentCompleted) {
                return 'text-warning';
            }
            return 'text-success';
        }

        function setCurrentStep() {
            if (isShowStep(vm.step1) && !isCompletedAgreementStep()) {
                return vm.currentStep = vm.step1;
            } else if (isShowStep(vm.step2) && !isCompletedNPQStep()) {
                return vm.currentStep = vm.step2;
            } else if (isShowStep(vm.step3) && !isCompletedHAQStep()) {
                return vm.currentStep = vm.step3;
            } else if (isShowStep(vm.stepPsychIntake) && !isCompletedPsychStep()) {
                return vm.currentStep = vm.stepPsychIntake;
            }
            return null;
        }

        function isCompletedAllStep() {
            if (vm.isPatientNoNPQ) {
                var a = [];
                angular.forEach(vm.langdingPageSteps, function (step) {
                    if (step && step.percentProgress < vm.percentCompleted) {
                        a.push(step);
                    }
                });
                return a.length === 0;
            }
            return isCompletedAgreementStep() && isCompletedNPQStep() && isCompletedPsychStep() && isCompletedHAQStep() && isCompletedAllHAQBatteryStep() && (isLaunchFromHaq() || isCompletedHAQAdhocStep());
        }

        function itemLandingPageClick(item) {
            if (item && item.isCurrentStep) {
                if (item.isAgreement) {
                    // go to agreement workflow
                    $state.go('agreements-workflow');
                }
                if (item.isHAQ) {
                    var haqInfo = vm.landingpage.haqResponseInfo;
                    if ((haqInfo.allowStartNewBattery === null || haqInfo.allowStartNewBattery === true || vm.byPassRestriction) &&
                        haqInfo.isEmailConfirmed === false && haqInfo.disposition == true) {

                        // display body part
                        vm.isDisplayHaqBodyPart = true;
                        Principal.identity(false).then(function (account) {
                            vm.account = account;
                            vm.emailConfirmed = false;
                            vm.email = account.email === null ? account.email : account.email.trim();
                            vm.hasEmail = vm.email;
                            vm.injuredType = account.injuredType;
                            vm.patientInjuredTypes = vm.landingpage.injuredTypes;
                        });


                    } else {

                        $window.localStorage.removeItem(constants.NOWAIT); // old code (4 year ago), don't know this bussiness

                        if (haqInfo.disposition == true) {
                            if (vm.byPassRestriction) {
                                if (haqInfo.status === 'COMPLETE' && haqInfo.courseRegisterConfirmed === false) {
                                    $state.go('course-registration-workflow');
                                } else {
                                    $state.go('survey-workflow', { id: vm.batteryTestId });
                                }
                                return;
                            }
                            if (haqInfo.status !== 'COMPLETE' && haqInfo.status !== 'INCOMPLETE' && haqInfo.status !== 'NO_RESULT' &&
                                (haqInfo.allowStartNewBattery == null || haqInfo.allowStartNewBattery == true || vm.byPassRestriction)) {
                                // go to  haq workflow

                                $state.go('survey-workflow', { id: vm.batteryTestId });
                            } else {
                                if (haqInfo.status === 'COMPLETE' && haqInfo.courseRegisterConfirmed === false) {
                                    $state.go('course-registration-workflow');
                                    return;
                                } else {
                                    vm.isCompleteHAQ = true;
                                }
                            }
                        } else {
                            vm.isInActiveHAQ = true;
                        }
                    }
                }
            }
        }

        function itemLandingPageClickDownload() {
            if (!vm.isProcessing) {
                clickToDownload();
            }
        }

        function handleHAQBodyPartSubmitSuccess() {
            $state.go('survey-workflow', { id: vm.batteryTestId });
        }

        function isDisplayItemLandingPageForPatientNoNPQ() {
            if (vm.isPatientNoNPQ) {
                return !vm.isDisplayHaqBodyPart;
            }
            return false;
        }

        function isDisplayItemLandingPageForAdhocTesting() {
            if (vm.isAdhocTesting) {
                return !vm.isDisplayHaqBodyPart;
            }
            return false;
        }

        function isAgreementSignedAllByAPI() {
            return vm.landingpage && vm.landingpage.agreement.agreementSignedAllByAPI;
        }
    }
})();
